import { CalendarRepository } from '../Repositories/CalendarRepository';

const calendarRepository = new CalendarRepository();

function createUser(callback, timeSlot) {
  return () => {
    calendarRepository.createUser().then(() => {
      callback(timeSlot);
    });
  };
}

function fetchUrls() {
  return dispatch => {
    calendarRepository.getProviders().then(response => {
      dispatch({
        type: 'GET_URLS',
        payload: response.data,
      });
    });
  };
}

function fetchSettings() {
  return dispatch => {
    return calendarRepository.getSettings().then(response => {
      dispatch({
        type: 'GET_SETTINGS',
        payload: response.data,
      });
      return response.data;
    }).catch(() => {
      dispatch({ type: 'GET_SETTINGS_FAILED' });
    });
  };
}

function setSettings(settings) {
  return dispatch => {
    return calendarRepository.setSettings(settings).then(({ zonedFields }) => {
      dispatch({
        type: 'SET_SETTINGS',
        payload: {
          StartingFreeTime: settings.workingHoursStart,
          EndingFreeTime: settings.workingHoursEnd,
          AvailableWeekDays: settings.availableWeekDays,
          SlotDuration: settings.SlotDuration,
          DefaultReminderTime: settings.DefaultReminderTime,
          BufferDuration: settings.BufferDuration,
          TimeZoneIds: settings.TimeZoneIds,
          ...(zonedFields || {}),
        },
      });
    });
  };
}

function revokeAccess(providers, callback) {
  return dispatch => {
    calendarRepository.revokeCalendars(providers).then(() => {
      dispatch({
        type: 'REVOKE_ACCESS',
        payload: providers,
      });
      fetchUrls()(dispatch);
      callback();
    });
  };
}

export { fetchUrls, fetchSettings, setSettings, revokeAccess, createUser };
